module.exports = __webpack_public_path__ + "static/media/uploadIcon.a09c9b70.svg";